import React from "react";

import {
  Box,
  TextField,
  Stack,
  IconButton,
  Tooltip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import FilterListAltIcon from "@mui/icons-material/FilterListAlt";

const UserFilter = ({
  type,
  setType,
  startDateTime,
  setStartDateTime,
  endDateTime,
  setEndDateTime,
  APICall,
}) => {
  return (
    <Box>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <FormControl fullWidth>
          <InputLabel id="categoria-label">Statistiche</InputLabel>
          <Select
            labelId="categoria-label"
            id="categoria-select"
            value={type}
            label="Statistica"
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="general">Generali</MenuItem>
            <MenuItem value="admin">Amministrazione</MenuItem>
            <MenuItem value="volunteer">Volontari</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Data e ora inizio"
          type="datetime-local"
          fullWidth
          value={startDateTime}
          onChange={(e) => setStartDateTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          label="Data e ora fine"
          type="datetime-local"
          fullWidth
          value={endDateTime}
          onChange={(e) => setEndDateTime(e.target.value)}
          InputLabelProps={{ shrink: true }}
        />
        <Tooltip title="Avvia ricerca filtri">
          <IconButton
            onClick={(e) => {
              e.preventDefault();
              APICall();
            }}
            sx={{
              color: "success.main",
              alignSelf: "center",
              justifyContent: "center",
            }}
          >
            <FilterListAltIcon />
          </IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );
};

export default UserFilter;
